import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webapps',
  templateUrl: './webapps.component.html',
  styleUrls: ['./webapps.component.css']
})
export class WebappsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
